<template>
  <div>
    <tr-list request="/BizMemberOrder/AllEffectiveList" ref="trList" :data="{Type: '租赁'}">
      <template slot="list" slot-scope="props">
        <router-link v-for="(item, index) in props.list" :key="index" :to="{path: '/equipment/renewalDetail', query: {Id: item.Id}}">
          <van-cell title="订单编号" is-link :value="item.State" :label="item.Code" />
        </router-link>
      </template>
    </tr-list>
  </div>
</template>

<script>
export default {
  name: 'renewal',
  data() {
    return {
    }
  },
  methods: {
    // getList
  }
}
</script>

<style scoped>

</style>
